const styles = {
  container: 'w-20 mr-3',
  fluidImage: 'max-w-full h-auto',
};
export default styles;
